module.exports = __webpack_public_path__ + "assets/img/b1d69a30027c3ffd951ce1cd0ffed384.png";